var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 33 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#twitter_svg__a)",
    d: "M25.99 0h5.06L19.995 11.86 33 28H22.815l-7.976-9.788L5.713 28H.65l11.825-12.686L0 0h10.44l7.21 8.947L25.986 0h.003Zm-1.776 25.157h2.803L8.918 2.694H5.91l18.305 22.463Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter_svg__a",
    x1: 5.765,
    x2: 25.674,
    y1: 2.284,
    y2: 2.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgTwitter;